module.exports = __webpack_public_path__ + "img/help-icon.afb3baa3.png";